import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Axios from "axios";
import Api from "./index";
import _ from "lodash";
import VueCookie from "./config/util.cookies";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VCharts from "v-charts";
import VueQriously from 'vue-qriously';

Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.use(ElementUI);
Vue.use(VCharts);
Vue.prototype.$Api = Api;
Vue.prototype._ = _;
Vue.use(VueQriously);
new Vue({
  router,
  Axios,
  store,
  render: h => h(App)
}).$mount("#app");
